import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteOteConType = ({ oteConTypeId }: { oteConTypeId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/OteConTypes/DeleteOteConType/${oteConTypeId}`);
};

type QueryFnType = typeof deleteOteConType;

type UseDeleteOteConTypeOptions = {
  oteConTypeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteOteConType = ({ config }: UseDeleteOteConTypeOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllOteConTypes"]);
      addNotification(`Το Είδος γραμμής ΟΤΕ Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteOteConType,
  });
};
